module.exports = __webpack_public_path__ + "img/WHATSAPP.86a3fa5b.svg";